// 1 TRX = 10^6 SUN (similar to wei for Ethereum)
export const SUN_PER_TRX = 1e6;
